export default "__VITE_ASSET__DoNwHtFe__"